import { listen, fire } from "../utils/events";
import { parse } from 'subtitle';

let splashRemoved = false;
let subsContent = "";
let subsTimeout = null;
let subsTimer = 0;
let subsPaused = false;

function initSubtitles() {
    const node = document.getElementById("subtitles");
    if(node) {
        const color = Q3.SlideManager.slides[Q3.SlideManager.activeSlide].subtitleColor;
        if(color) {
            node.style.color = color;
            // let invertedColor = ("000000" + (0xFFFFFF ^ parseInt(color.substring(1), 16)).toString(16)).slice(-6);
            // node.style.textShadow = `0 0.03em 0.03em #${invertedColor}`;
        }

        const bgColor = Q3.SlideManager.slides[Q3.SlideManager.activeSlide].subtitleBgColor || "#FFFFFF";
        const opacity = Q3.SlideManager.slides[Q3.SlideManager.activeSlide].subtitleBgOpacity || 0;
        const fontSize = Q3.SlideManager.slides[Q3.SlideManager.activeSlide].subtitleFontSize || 2;

        const [r, g, b] = bgColor.match(/\w\w/g).map(x => parseInt(x, 16));
        node.style.backgroundColor = `rgba(${r},${g},${b},${opacity})`;
        node.style.fontSize = `${fontSize}rem`;
    }
    loadSubs()
        .then( response => {
            subsContent = response;
        });

    listen('splashremoved', () => {
        showSubs();
        splashRemoved = true;
    });

    listen('slidechange', () => {
        clearTimeout(subsTimeout);
        if(splashRemoved) {
            loadSubs()
                .then( response => {
                    subsContent = response;
                    showSubs();
                });
        }
    });

    listen('autoplay_pause', () => {
        subsPaused = true;
    });

    listen('autoplay_resume', () => {
        subsPaused = false;
        showSubs();
    });
}

async function loadSubs() {
    const slide = Q3.SlideManager.slides[Q3.SlideManager.activeSlide];
    if(slide.subtitle) {
        let response = await fetch(slide.subtitle);
        return await response.text();
    }
    else {
        return "";
    }
}

function sleep(ms) {
    return new Promise(resolve => {
        subsTimeout = setTimeout(resolve, ms)
    });
}

function paused() {
    if(subsPaused) {
        clearTimeout(subsTimeout);
    }
    return subsPaused;
}

async function showSubs() {
    const subs = parse(subsContent);
    const node = document.getElementById("subtitles");
    node.innerHTML = "";
    if (node) {
        for (let i = 0; i < subs.length; ++i) {
            const item = subs[i];
            if (item.start >= subsTimer) {
                if(paused()) break;
                await sleep(item.start - subsTimer);
                if(paused()) break;
                subsTimer = item.start;
            }
            else {
                continue;
            }
            node.innerHTML = item.text;
            if(paused()) break;
            await sleep(item.end - item.start);
            if(paused()) break;
            node.innerHTML = "";
            subsTimer = item.end;
        }
    }
}

export default initSubtitles;
export {initSubtitles, loadSubs};
